import { render } from "./Topic.vue?vue&type=template&id=7be34b47&scoped=true"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"

import "./Topic.vue?vue&type=style&index=0&id=7be34b47&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7be34b47"

export default script